import react from 'react'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from "pdfmake/build/vfs_fonts"
import { HeaderPDF, MovimentacaoProduto } from '../../../Utils/Types';
import { Funcoes } from '../../../Utils/Funcoes';
import moment from 'moment';

export class MovimentacaoPDF {

  private headers: HeaderPDF[] = []
  private movimentacaoList: MovimentacaoProduto[]
  private body: any
  private corpoDocumento: any
  private descProd: string
  private descVariacaoGrade: string
  private descSubVariacaoGrade: string
  private datai: string
  private dataf: string
  private totEnt: number
  private totSai: number
  private dadosEmpresa: any

  constructor(movimentacaoList: MovimentacaoProduto[], descProd: string, descVariacaoGrade: string, descSubVariacaoGrade: string, datai: string, dataf: string, totEnt: number, totSai: number) {
    this.movimentacaoList = movimentacaoList
    this.descProd = descProd
    this.descVariacaoGrade = descVariacaoGrade
    this.descSubVariacaoGrade = descSubVariacaoGrade
    this.datai = datai
    this.dataf = dataf
    this.totEnt = totEnt
    this.totSai = totSai
  }

  async CriaDocumento() {
    const bBody: any = this.movimentacaoList.map((mov) => {
      return [
        { text: mov.dhInsert, fontSize: 10 },
        { text: mov.doc, fontSize: 10 },
        { text: mov.tipo === 'E' ? 'Entrada' : 'Saída', fontSize: 10 },
        { text: mov.observacao, fontSize: 10 },
        { text: mov.qtd, fontSize: 10 },
        { text: mov.acumulado, fontSize: 10 },
      ]
    })

    this.body = [
      { text: 'Data', fontSize: 10 },
      { text: 'Documento', fontSize: 10 },
      { text: 'Ent/Sai', fontSize: 10 },
      { text: "Observação", fontSize: 10 },
      { text: "Quantidade", fontSize: 10 },
      { text: "Acumulado", fontSize: 10 },
    ]

    const lineHeader = [
      {
        text: '____________________________________________________________________________________________________________________________________________________________________________',
        aligment: 'center',
        fontSize: 5,
        colSpan: 3
      }, {}, {},
    ]

    let content = [this.headers, lineHeader];
    content = [...content, ...this.body];
    this.corpoDocumento = content;
  }

  GerarDocumento() {

    const document = {
      pageSize: 'A4',
      pageMargins: [14, 53, 14, 48],
      header: () => {
        return {
          margin: [14, 12, 14, 0],
          layout: 'noBorders',
          table: {
            widths: ['*'],
            body: [
              [
                { text: 'Movimentação de Produtos', style: 'reportName' }
              ]
            ],
          },
        };
      },
      content: [
        {
          layout: 'noBorders',
          table: {
            headerRows: 1,
            widths: ['*', 55, 55],
            body: this.corpoDocumento
          }
        },
      ],
      footer: (currentPage: number, pageCount: number) => {
        return {
          layout: 'noBorders',
          margin: [14, 0, 14, 22],
          table: {
            widths: ['auto'],
            body: [
              [
                {
                  text: '_________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________',
                  alignment: 'center',
                  fontSize: 5,
                },
              ],
              [
                [
                  {
                    text: `Página ${currentPage.toString()} de ${pageCount}`,
                    fontSize: 7,
                    alignment: 'right',
                    // horizontal, vertical
                    margin: [3, 0],
                  },
                  {
                    text: '© Lojinha de TI',
                    fontSize: 7,
                    alignment: 'center',
                  },
                ],
              ],
            ],
          },
        };
      },
      styles: {
        reportName: {
          fontSize: 9,
          bold: true,
          alignment: 'center',
          margin: [0, 4, 0, 0],
        }
      },
    };

    return document;
  }

  async GerarPDF(movimentacaoList: MovimentacaoProduto[]) {

    this.dadosEmpresa = Funcoes.GetDadosEmpresa()


    pdfMake.vfs = pdfFonts.pdfMake.vfs

    let dados = movimentacaoList.map((item: MovimentacaoProduto) => {
      return [
        { text: moment(item.dhInsert).format("DD/MM/YYYY"), alignment: 'left', fontSize: 9, margin: [10, 2, 0, 2], border: [false, true, true, true], },
        { text: item.doc, alignment: 'left', fontSize: 9, margin: [0, 2, 0, 2], border: [false, true, true, true], },
        { text: item.tipo === 'E' ? 'Entrada' : 'Saída', alignment: 'left', fontSize: 9, margin: [0, 2, 0, 2], border: [false, true, true, true], },
        { text: '', alignment: 'right', fontSize: 9, margin: [0, 2, 0, 2], border: [false, true, true, true], },
        { text: Funcoes.numberFormat(item.qtd, 'decimal', 2, 2,), alignment: 'right', fontSize: 9, margin: [0, 2, 0, 2], border: [false, true, true, true], },
        { text: Funcoes.numberFormat(item.acumulado, 'decimal', 2, 2,), alignment: 'right', fontSize: 9, margin: [0, 2, 0, 2], border: [false, true, false, true], },
      ]
    })

    const details: any = [
      {
        layout: 'noBorders',
        margin: 0,
        table: {
          widths: ['*', '*', '*', '*', '*', '*'],
          body: dados
        },
      }
    ]

    const footer = (currentPage: number, pageCount: number,) => {
      return [
        {
          layout: 'Borders',
          style: 'tableExample',
          margin: [50, 0, 50, 50],
          table: {
            headerRows: 1,
            widths: ['*'],
            body: [
              [{ text: 'Pág. ' + currentPage + '/' + pageCount, alignment: 'right', fontSize: 10, margin: [50, 0, 50, 0], border: [false, true, false, false] }],
            ]
          }
        },
      ]
    };

    const docDefinitions: any = {
      pageSize: 'A4',
      pageMargins: [25, 0, 25, 50],
      content: [
        /* Dados da Empresa Início */
        {
          layout: 'Borders',
          style: 'tableExample',
          table: {
            headerRows: 1,
            widths: ['*'],
            body: [
              [{ text: this.dadosEmpresa?.fantasia || '', bold: true, alignment: 'center', margin: [0, 5, 0, 0], fontSize: 13, border: [false, false, false, false] },],
              [{ text: 'CNPJ: ' + (Funcoes.FormatDoc(this.dadosEmpresa?.cnpj_cpf) || ''), bold: true, alignment: 'center', margin: [0, 2, 0, 0], fontSize: 13, border: [false, false, false, false] },],
              [{ text: (this.dadosEmpresa?.endereco || '') + (this.dadosEmpresa?.numero ? " N." + this.dadosEmpresa?.numero : '') + ' ' + (this.dadosEmpresa?.bairro || ''), bold: true, alignment: 'center', margin: [0, 2, 0, 0], fontSize: 13, border: [false, false, false, false] },],
              [{ text: (this.dadosEmpresa?.cidade || '') + " - " + (this.dadosEmpresa?.uf || ''), bold: true, alignment: 'center', margin: [0, 2, 0, 0], fontSize: 13, border: [false, false, false, false] },],
            ],
          },
        },
        /* Dados da Empresa Fim*/

        {
          layout: 'Borders',
          style: 'tableExample',
          table: {
            headerRows: 1,
            widths: ['*'],
            body: [
              [{ text: 'Movimentação de Produtos', alignment: 'center', bold: true, fontSize: 12, border: [false, false, false, true], style: 'header', margin: [0, 2, 0, 2] },],
            ],
          },
        },
        {
          layout: 'Borders',
          style: 'tableExample',
          table: {
            headerRows: 1,
            widths: ['*', '*', '*'],
            body: [
              [
                { text: 'Produto: ' + this.descProd + ' ' + this.descVariacaoGrade + ' - ' + this.descSubVariacaoGrade, bold: false, margin: [0, 0, 0, 0], fontSize: 10, border: [false, false, false, false] },
                { text: 'Período: ' + moment(this.datai).format('DD/MM/YYYY') + ' - ' + moment(this.dataf).format('DD/MM/YYYY'), fontSize: 10, bold: false, margin: [5, 0, 0, 0], border: [false, false, false, false] },
                { text: 'Data impressão: ' + (new Date()).toLocaleDateString('pt-BR'), alignment: 'right', fontSize: 10, margin: [5, 0, 0, 0], border: [false, false, false, false], bold: false, },
              ],
              [
                { text: 'Entradas: ' + Funcoes.numberFormat(this.totEnt, 'decimal', 0, 0,), bold: false, margin: [0, 0, 0, 0], fontSize: 10, border: [false, false, false, false] },
                { text: 'Saidas: ' + Funcoes.numberFormat(this.totSai, 'decimal', 0, 0,), bold: false, margin: [5, 0, 0, 0], fontSize: 10, border: [false, false, false, false] },
                { text: 'Saldo: ' + Funcoes.numberFormat(this.totEnt - this.totSai, 'decimal', 0, 0,), bold: false, margin: [5, 0, 0, 0], alignment: 'right', fontSize: 10, border: [false, false, false, false] },
              ]
            ],
          },
        },
        {
          layout: 'Borders',
          style: 'tableExample',
          table: {
            widths: ['*', '*', '*', '*', '*', '*'],
            body: [
              [
                { text: 'Data', alignment: 'center', fontSize: 10, margin: [0, 4, 0, 4], border: [false, true, true, false] },
                { text: 'Documento', alignment: 'center', fontSize: 10, margin: [0, 4, 0, 4], border: [false, true, true, false] },
                { text: 'Ent/Sai', alignment: 'center', fontSize: 10, margin: [0, 4, 0, 4], border: [false, true, true, false] },
                { text: 'Observação', alignment: 'center', fontSize: 10, margin: [0, 4, 0, 4], border: [false, true, true, false] },
                { text: 'Quantidade', alignment: 'center', fontSize: 10, margin: [0, 4, 0, 4], border: [false, true, true, false] },
                { text: 'Acumulado', alignment: 'center', fontSize: 10, margin: [0, 4, 0, 4], border: [false, true, false, false] },
              ],
            ],
          },
        },
        {
          layout: 'Borders',
          style: 'tableExample',
          margin: [0, 0, 0, 0],
          table: {
            widths: ['*', "*", '*', '*', '*', '*'],
            body: dados
          },
        }

      ],
      footer: footer
    };

    pdfMake.createPdf(docDefinitions).print();

  }

}